import { render } from "./fileType.vue?vue&type=template&id=1041459b&scoped=true"
import script from "./fileType.vue?vue&type=script&lang=js"
export * from "./fileType.vue?vue&type=script&lang=js"

import "./fileType.vue?vue&type=style&index=0&id=1041459b&scoped=true&lang=css"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1041459b"]])

export default __exports__